import { render } from "./ProjectSvgIcon.vue?vue&type=template&id=1059af36"
import script from "./ProjectSvgIcon.vue?vue&type=script&lang=js"
export * from "./ProjectSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__